export const FETCH_SUPPORT_DASHBOARD = "FETCH_SUPPORT_DASHBOARD";
export const FETCH_SUPPORT_DASHBOARD_SUCCESS = "FETCH_SUPPORT_DASHBOARD_SUCCESS";
export const FETCH_SUPPORT_DASHBOARD_FAILURE = "FETCH_SUPPORT_DASHBOARD_FAILURE";
export const RESET_SUPPORT_DASHBOARD_LOADING = "RESET_SUPPORT_DASHBOARD_LOADING";

export const resetSupportDashboardLoading = () => ({
    type: RESET_SUPPORT_DASHBOARD_LOADING,
});

export const fetchSupportDashboard = (resourceId) => ({
    type: FETCH_SUPPORT_DASHBOARD,
    payload: { resourceId },
});

export const fetchSupportDashboardSuccess = (data) => ({
    type: FETCH_SUPPORT_DASHBOARD_SUCCESS,
    payload: { data },
});

export const fetchSupportDashboardFailure = (error) => ({
    type: FETCH_SUPPORT_DASHBOARD_FAILURE,
    payload: { error },
});
